import React from "react";
import "./SpectraRowLegend.scss";

export const SpectraRowLegend: React.FC = () => {
    return (
        <div className="spectra-row-legend">
            <div className="row header d-none d-md-flex">
                <div className="col-12 col-md-4">
                    ID category
                </div>
                <div className="col-12 col-md-4 text-md-center">
                    score range
                </div>
                <div className="col-12 col-md-4 text-md-end">
                    expected specificity
                </div>
            </div>
            <div className="result-qualified row">
                <div className="col-12 col-md-4 position-relative">
                    <span className="ball"></span> Qualified result
                </div>
                <div className="col-12 col-md-4 text-md-center">
                            <span className="d-block d-md-none fw-bold">
                                score range:
                              </span>
                    90.00-99.99%
                </div>
                <div className="col-12 col-md-4 text-md-end">
                            <span className="d-block d-md-none fw-bold">
                               expected specificity:
                              </span>
                    {">"} 99%
                </div>
            </div>
            <div className="result-not-qualified row">
                <div className="col-12 col-md-4 position-relative">
                    <span className="ball"></span> Non-Qaulified result
                </div>
                <div className="col-12 col-md-4 text-md-center">
                            <span className="d-block d-md-none fw-bold">
                                score range:
                              </span>
                    70.00-89.99%
                </div>
                <div className="col-12 col-md-4 text-md-end">
                            <span className="d-block d-md-none fw-bold">
                               expected specificity:
                              </span>
                    80-99%
                </div>
            </div>
            <div className="result-none row">
                <div className="col-12 col-md-4 position-relative">
                    <span className="ball"></span> Non-Qaulified result
                </div>
                <div className="col-12 col-md-4 text-md-center">
                            <span className="d-block d-md-none fw-bold">
                                score range:
                              </span>
                    50.00-69.99%
                </div>
                <div className="col-12 col-md-4 text-md-end">
                            <span className="d-block d-md-none fw-bold">
                               expected specificity:
                              </span>
                    {"<"} 80%
                </div>
            </div>
        </div>
    )
}

